import React from 'react'
import { Button } from 'reactstrap'

function InstanceSearchButton({ onSearch }) {
  return (
    <Button type="button" className="btn-card-primary instance-search-button" onClick={onSearch}>
      Buscar
    </Button>
  )
}

export default InstanceSearchButton